<!-- CustomNotification.vue -->
<template>
  <div :class="['notification flex gap-2.5', title ? 'items-start' : 'items-center', type]">
    <img :src="imgSrc">
    <div>
      <p v-if="title" class="title">{{ title }}</p>
      <p class="message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
        default: 'info', // 'success', 'error', 'warning', 'info'
      },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: 'This is a message',
    }
  },
  computed: {
    imgSrc() {
      return require(`@/assets/NewLibrary/notification/${this.type}_icon.svg`)
    }
  }
}
</script>

<style scoped>
.notification {
  border-radius: 8px;
  padding: 10px 16px;
  box-shadow: 0 2px 12px 0 rgba(74, 74, 74, 0.25);
  width: 100%;
  min-height: 85px;
}

.title {
  font-weight: bold;
  font-family: "IBM Plex Sans Hebrew";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.message {
  font-family: "IBM Plex Sans Hebrew";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px;
}

.success {
  background-color: #EBFFF8;
  color: #25B8C2;
}

.error {
  background-color: #FAEAEA;
  color: #D10000;
}

.warning  {
  background-color: #FEF9E9;
  color: #f39c12;

  .title {
    color: #E0961E;
  }

  .message {
    color: #333;
  }
}


.info {
  background-color: #E8F4FD;

  .title {
    color: #004879;
  }

  .message {
    color: #333;
  }
}
</style>
  
